import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePlanReviewCandidateMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  set: Types.Plan_Review_Requirement_Candidates_Set_Input;
}>;


export type UpdatePlanReviewCandidateMutation = { __typename?: 'mutation_root', update_plan_review_requirement_candidates_by_pk?: { __typename?: 'plan_review_requirement_candidates', id: any } | null };


export const UpdatePlanReviewCandidateDocument = gql`
    mutation updatePlanReviewCandidate($id: uuid!, $set: plan_review_requirement_candidates_set_input!) {
  update_plan_review_requirement_candidates_by_pk(
    pk_columns: {id: $id}
    _set: $set
  ) {
    id
  }
}
    `;
export type UpdatePlanReviewCandidateMutationFn = Apollo.MutationFunction<UpdatePlanReviewCandidateMutation, UpdatePlanReviewCandidateMutationVariables>;

/**
 * __useUpdatePlanReviewCandidateMutation__
 *
 * To run a mutation, you first call `useUpdatePlanReviewCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanReviewCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanReviewCandidateMutation, { data, loading, error }] = useUpdatePlanReviewCandidateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdatePlanReviewCandidateMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlanReviewCandidateMutation, UpdatePlanReviewCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlanReviewCandidateMutation, UpdatePlanReviewCandidateMutationVariables>(UpdatePlanReviewCandidateDocument, options);
      }
export type UpdatePlanReviewCandidateMutationHookResult = ReturnType<typeof useUpdatePlanReviewCandidateMutation>;
export type UpdatePlanReviewCandidateMutationResult = Apollo.MutationResult<UpdatePlanReviewCandidateMutation>;
export type UpdatePlanReviewCandidateMutationOptions = Apollo.BaseMutationOptions<UpdatePlanReviewCandidateMutation, UpdatePlanReviewCandidateMutationVariables>;